import React from "react";
import { Container } from "react-bootstrap";
import classes from "./DesktopFooter.module.css";
import {
  AiFillFacebook,
  AiFillLinkedin,
  AiFillInstagram,
} from "react-icons/ai";
import { IoLogoYoutube } from "react-icons/io";
import { SocialIcon } from "react-social-icons";

function DesktopFooter({ containerClass, links }) {
  return (
    <div className={classes.footer}>
      <Container
        fluid
        className={`${[
          classes.container,
          containerClass && containerClass,
        ].join(" ")}`}
      >
        <div className={classes.content}>
          <div>
            <h3>
              <a href="#navDesktopHeader">Card-Creator.com</a>
            </h3>
          </div>
          <p>&copy;copyright 2022 your logo. All Rights Reserved.</p>
          <div className={classes.socialIcons}>
            {/* <AiFillFacebook className={classes.icon} />
            <AiFillInstagram className={classes.icon} />
            <AiFillLinkedin className={classes.icon} />
            <IoLogoYoutube className={classes.icon} /> */}
            {links?.map((e, i) => (
              <SocialIcon
                key={i}
                url={e?.link}
                bgColor="#eee"
                target="_blank"
                style={{
                  marginRight: "5px",
                  width: "25px",
                  height: "25px",
                }}
              />
            ))}
          </div>
        </div>
      </Container>
    </div>
  );
}

export default DesktopFooter;
